/**
 * Marks a page-level sticky bar — the TopNav, and the access review's navigator
 * and state bar. Content that sticks to the page (the reviewer's table,
 * PLO-6216) measures these to park below the lowest one instead of under it.
 */
export const STICKY_CHROME_ATTR = "data-sticky-chrome";

/** Spread onto a sticky bar's root element. */
export const STICKY_CHROME_PROPS = { [STICKY_CHROME_ATTR]: "" };
